module.exports = __webpack_public_path__ + "img/5.53d51c3a.png";